/** Normaliza nombres de tipo de vehículo (espacios, mayúsculas). */
export const normalizeCarTypeName = (name) => {
    if (name == null || name === '') return '';
    return String(name).trim().replace(/\s+/g, ' ');
};

const MAQUINARIA_HINTS = ['maquinaria', 'machinery', 'grua', 'grúa', 'tow', 'plataforma', 'winch', 'arrastre'];
const MOTOS_HINTS = ['moto', 'motorcycle', 'motos_'];
const CARROS_HINTS = ['carro', 'car', 'auto', 'carros_'];

export const carTypeFamily = (name) => {
    const n = normalizeCarTypeName(name).toLowerCase();
    if (!n) return '';
    if (MAQUINARIA_HINTS.some((h) => n.includes(h))) return 'maquinaria';
    if (MOTOS_HINTS.some((h) => n.includes(h))) return 'motos';
    if (CARROS_HINTS.some((h) => n.includes(h))) return 'carros';
    return n;
};

export const carTypesMatch = (a, b) => {
    const left = normalizeCarTypeName(a).toLowerCase();
    const right = normalizeCarTypeName(b).toLowerCase();
    if (!left || !right) return true;
    if (left === right) return true;
    const familyA = carTypeFamily(a);
    const familyB = carTypeFamily(b);
    return familyA && familyB && familyA === familyB;
};

const CAR_TYPE_FALLBACK_LABELS = {
    carros_: 'Carros',
    motos_: 'Motos',
    maquinaria_: 'Maquinaria',
};

export const getCarTypeFallbackLabel = (name) => {
    const normalized = normalizeCarTypeName(name);
    if (!normalized) return '';
    const lower = normalized.toLowerCase();
    if (lower.includes('carro') || lower.includes('car')) return 'Carros';
    if (lower.includes('moto')) return 'Motos';
    if (lower.includes('maquinaria') || lower.includes('machinery')) return 'Maquinaria';
    return normalized;
};

export const getCarTypeLabelFromKey = (langKey) =>
    CAR_TYPE_FALLBACK_LABELS[langKey] || null;
